<template>
  <div class="chapterOne">
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第3章 真实世界的AI（9 朴素贝叶斯分类）</div>
      <div style="marginTop:30px;fontSize:12px;color:rgb(153,153,153);">2020-3-14 20:12:32</div>
      <div class="text fontBig">现代AI方法之所以能在现实世界中实际发挥作用，主要是因为它处理不确定性因素的能力较强，而不象1960-1980年代早期的大多数老式方法那样，对不确定性问题显得无能为力。</div>
      <div class="text fontBig">在第 3 章中，我们将介绍以下三部分内容。</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpOne">一、<span style="color:#0090ff;textDecoration:underline;">概率和优势比</span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpTow">二、<span style="color:#0090ff;textDecoration:underline;">贝叶斯规则 </span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpThree">三、<span style="color:#0090ff;textDecoration:underline;">朴素贝叶斯分类 </span>（0/2）</div>
      <div id="productId"><div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第3节 朴素贝叶斯分类</div></div>
      <div class="text fontBig">贝叶斯规则最有用的应用之一是所谓的朴素贝叶斯分类器。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">一、贝叶斯分类器</div>
      <div class="text fontBig">贝叶斯分类器是一种机器学习技术，可用于将诸如文本文档之类的对象分类为两个或更多个类。通过分析一组训练数据对分类器进行训练，为其提供正确的类别。</div>
      <div class="text fontBig">我们将使用垃圾邮件过滤器作为运行示例，以说明朴素贝叶斯分类器的思想。因此，类变量指示消息是垃圾消息（或“垃圾邮件”）还是合法消息。消息中的单词与特征变量相对应，因此模型中特征变量的数量由消息的长度决定。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">1. 为什么我们称其为“朴素”</div>
      <div class="text fontBig">以垃圾邮件过滤为例。基本思路：邮件是通过一个接一个的单词所产生的，这样，单词的选择就仅取决于消息是垃圾消息还是合法消息。这是对邮件过滤过程的粗略简化，因为它意味着相邻单词之间没有依存关系，单词的顺序也没有意义。这就是为什么该方法称为朴素的原因。</div>
      <div class="text fontBig">通常使用下图所示来描述上述想法，其中消息的类别（垃圾消息或合法消息）是唯一影响单词的因素。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/09-01.png" alt="">
      <div class="text fontBig">尽管朴素贝叶斯方法很幼稚，但在实践中往往效果很好。这正应了统计学中的一句俗语“所有模型都是错误的，但有些模型是有用的”。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">2. 估计参数</div>
      <div class="text fontBig">首先，我们需要指定垃圾邮件的事前优势比（针对合法邮件而言）。为简单起见，假设此优势比为1:1，这意味着平均一半的传入消息是垃圾（实际上，垃圾的数量可能要高得多）。</div>
      <div class="text fontBig">为了获得似然比，对于任何出现的单词，我们需要两种不同的概率，一种是垃圾消息的概率，另一种是合法消息的概率。</div>
      <div class="text fontBig">两种概率的确定最好从包含一些垃圾消息和合法消息的实际培训数据中来进行估计，最简单的方法是计算它们中每个单词出现的次数，然后将其除以总单词数。</div>
      <div class="text fontBig">为了说明这个想法，我们假设可以使用一些垃圾消息和一些合法消息，并将其分别保存在两个文件中。</div>
      <div class="text fontBig">假设我们已经分别将垃圾消息和合法消息在文件中出现的次数，以及每个文件的总单词数都计算出来了，如表1所示。</div>
      <div class="text fontBig" style="textAlign:center;">表1 两个文件中的垃圾/合法消息及总单词数</div>
      <img style="width:230px;marginLeft:220px" src="../assets/09-02.png" alt="">
      <div class="text fontBig">现在，我们可以看出垃圾消息中一个单词为“百万”的概率为95791中有156个，估算为614中有1。同样，我们得出它在合法消息中的值为306438个单词中有98个，估算为3127中的1个相同。这两个概率估算值都很小，小于500分之1，但更重要的是，前者高于后者：614分之1高于3127分之1。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">3. 似然比</div>
      <div class="text fontBig">似然比(likelihood ratio, LR) 是反映真实性的一种指标，属于同时反映灵敏度和特异度的复合指标。例如，有病者中得出某一筛检试验结果的概率与无病者得出这一概率的比值。</div>
      <div class="text fontBig">显然，在本节的垃圾邮件过滤实例中，这意味着似然比等于第一优势比（垃圾消息概率）除以第二个优势比（合法消息概率），大于1。更准确地说，比值为（1/614）/（1/3127）= 3127/614 = 5.1（四舍五入到一位小数）。</div>
      <div class="text fontBig"><b>注意：零意味着麻烦</b>，比如0/0或x/0，将导致没有意义的比值。因而，若出现0/0或x/0的情况，就将其中的0用一个较小的下限值来替代。例如“会议”在垃圾消息中出现次数为0，其垃圾消息的优势比就用一个小的值如1/100000替代。</div>
      <div class="text fontBig">使用以上逻辑，我们可以确定所有可能单词的似然比，而不必使用零，从而得出以下似然比，如表2所示。</div>
      <div class="text fontBig" style="textAlign:center;">表2 垃圾/合法邮件似然比</div>
      <img style="width:130px;marginLeft:280px" src="../assets/09-03.png" alt="">
      <div class="text fontBig">现在，我们准备应用该方法对新邮件进行分类。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">二、示例：是垃圾信息还是合法信息？</div>
      <div class="text fontBig">一旦计算出事前优势比和似然比，就可以应用贝叶斯规则了，该规则已经在医学诊断案例中得到了实践。推理与以前一样：我们将垃圾信息的优势比乘以似然比来更新其优势比。为了让我们想起该过程，让我们尝试从只有一个单词的消息开始。对于以上约定的事前优势比，您应该使用优势比1:1。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">【知识巩固】</div>
      <div class="text fontBig"><b>练习12：一个单词的垃圾邮件过滤器</b>（Ref/5.1）</div>
      <div class="text fontBig">让我们从一条只有一个词的消息开始：“百万”。</div>
      <div class="text fontBig">您的任务：从上一个优势比1:1开始，使用上表计算给定该单词的垃圾消息的事后优势比。请记住，优势比与概率是不一样的，我们通常会表示为一个百分比。</div>
      <div class="text fontBig"><b>以一个十进制数x.x的形式给出答案，用点“.”作为十进制分隔符</b></div>
      <div class="text fontBig">（请记住，优势比可以表示为xx:yy或简单地表示为一个十进制数字，例如zz（其中zz = xx / yy）。</div>
      <div class="text fontBig" style="textAlign:center;">回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <button class="sentBtn" style="marginLeft:290px;" @click="sentBtn">提交</button>
      <div class="text fontBig">要处理消息中的其余单词，我们可以使用完全相同的过程。您在上一个练习中计算出的一个单词的事后优势比将成为下一个单词的事前优势比，依此类推。</div>
      <div class="text fontBig"><b>练习13：完整的垃圾邮件过滤器</b>（Ref/65.1168）</div>
      <div class="text fontBig">现在使用给定的消息“百万美元点击会议”，使用朴素的贝叶斯方法来计算垃圾邮件的事后优势比。</div>
      <div class="text fontBig">您应该再次从事前优势比1:1开始，然后将优势比重复乘以四个单词中每个单词的似然比。请注意，上面列出了似然比以供参考（这些数字是5.1、0.8等）。</div>
      <div class="text fontBig">您的任务：将结果表示为事后优势比，而不对结果进行任何取整。您可以查看上一个练习的解决方案以寻求帮助。</div>
      <div class="text fontBig" style="textAlign:center;">回答：<input type="text" class="anwserInput" :disabled="contenteditableOne"></div>
      <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>
      <div class="text fontBig">万岁！您现在已经掌握了朴素贝叶斯分类器这种强大的技术，它每天都在各种实际的AI应用程序中使用。即使您不得不跳过某些技术细节，也应尝试确保您了解应用概率更新信念的基本原则。正如我们在本章开头所讨论的那样，概率推理的主要优点是能够处理不确定和冲突的证据。通过医疗诊断和垃圾邮件过滤中的示例，我们演示了这是如何工作的。</div>
      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      choosesix:'',
      chooseseven:'',
      chooseeight:'',
      choosenine:'',
      isDisabledOne:false,
      contenteditable:false,
      contenteditableOne:false,
    }
  },
  methods:{
    sentBtn(){
      this.contenteditable = true;
    },
    sentBtnOne(){
      this.contenteditableOne = true;
    },
    jumpThree(){
       const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    jumpOne(){
      this.$router.push('/chapterSeven');
    },
    jumpTow(){
      this.$router.push('/chapterEight');
    },
    goBlank(){
      this.$router.push('/chapterEight');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/lessonTen');
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
.text{
    text-indent:2em;
}
.fontBig{
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 30px;
    
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.anwser{
  width: 200px;
  height: 200px;
  border: 1px dashed black;
  margin-left: 230px;
  overflow:auto;
  font-size: 14px;
  outline: none;
  margin-top: 10px;
  padding: 10px;
}
.anwserInput{
  border: none;
  outline: none;
  border-bottom: 1px solid;
  font-size:16px;
}
.backBtn button{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapterNine.vue